<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
import StrIsoIcTetkik from "@/models/StrIsoIcTetkik";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
 
export default {
  mixins: [Api, Sabit, StrIsoIcTetkik],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,  BirimSecimi , formcombobox
  },
  data() {
    return {
      title: "İç Tetkik Uygunsuzluklar",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kalite Yönetim Sistemi (ISO 9001) Çalışmaları",
        },
        {
          text: "İç Tetkik Uygunsuzluklar",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Birimid: null,
        Yil: null
      },
      DetayId: null,
      OPersonelid: null,
      FormData: null,
      Tetkikid: null,
      Tetkik: null,
      GetFilter: null
    };
  },

  methods: {
    Get() {
        this.TableGet()
    },
    TableGet(){
  
          this.GetFilter =  ""
          if (this.Filter.Birimid != null) { this.GetFilter += "&Birimid=" + this.Filter.Birimid }
          if (this.Filter.Yil != null) { this.GetFilter += "&Yil=" + this.Filter.Yil }

          this.ActionsFilterGet({ Service: "StrIsoIcTetkik/GetUygunsuzluklar", Page: this.Page, Filter: this.GetFilter }).then((res) => {
            this.TableData = res.Data;
            this.Page.PageDataSize = res.TotalCount;
          });
   

    },
 

    
  },
  async created() {
 

  }
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <BirimSecimi class="mb-3 col-md-3" title="Birim" :sutun="'0'" :title_position="'mb-3'"
                  :selected="Filter.Birimid" :labels_lg="'3'" :v="$v.Filter.Birimid" :multiple="false"
                  :BirimTipId="null" @Secilmis_Idler="Filter.Birimid = $event" />
 
                  <formcombobox class="col-md-3" :FormDataType="FormDataType.Yil" :Value="Filter.Yil"
                  :v="$v.Filter.Yil" @input="Filter.Yil = $event" />

                <div class="col-sm-2 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="Get()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>


                <div class="col-sm-4 ">
                  <div class="text-sm-end">   <b-dropdown variant="success" class="btn  btn-rounded mb-2 me-2">
            <template v-slot:button-content>
              <i class="mdi mdi-file-export-outline me-1"></i>Yazdır <i class="mdi mdi-chevron-down"></i>
            </template>
            <b-dropdown-item href="javascript: void(0);"
              @click="Report({ Service: 'StrIsoIcTetkik/print/Uygunsuzluklar', DowlandName: 'İç Tetkik Uygunsuzluklar', FileName: 'StrIsoIcTetkikUygunsuzluklar', FileFormat: 'xlsx', Filter: GetFilter })">Excel</b-dropdown-item>
            <b-dropdown-item href="javascript: void(0);"
              @click="Report({ Service: 'StrIsoIcTetkik/print/Uygunsuzluklar', DowlandName: 'İç Tetkik Uygunsuzluklar', FileName: 'StrIsoIcTetkikUygunsuzluklar', FileFormat: 'pdf', Filter: GetFilter })">Pdf</b-dropdown-item>
            <b-dropdown-item href="javascript: void(0);"
              @click="Report({ Service: 'StrIsoIcTetkik/print/Uygunsuzluklar', DowlandName: 'İç Tetkik Uygunsuzluklar', FileName: 'StrIsoIcTetkikUygunsuzluklar', FileFormat: 'docx', Filter: GetFilter })">Word</b-dropdown-item>
          </b-dropdown>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Tetkik Edilen Birim</th>
                      <th>Tetkik Tarihi ve Saati</th>
                      <th>Tetkik Yeri</th>
                      <th>No</th>
                      <th>Düzey</th>
                      <th>Tanım</th>
                      <th>İyileştirme</th>
                      <th>Ön Görülen İyileştirme Tarihi</th> 
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Birim }}</th>
                      <td>{{ Data.Tarih | formatDateTable }} {{ Data.Saat }}</td>
                      <td>{{ Data.Yer }}</td> 
                      <td>{{ Data.No }}</td> 
                      <td>{{ Data.Duzey }}</td> 
                      <td>{{ Data.Tanim }}</td> 
                      <td>{{ Data.Iyilestirme }}</td> 
                      <td>{{ Data.OnGorulenIyilestirmeTarihi }}</td>  
                       
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

 
    </Layout>
  </Loader>
</template>
